import { clientEnv } from '@/env';
import { makeAppLogger } from '@listening/frontend/logging/app-logger';

const isBrowser = typeof window !== 'undefined';
const isNode = !isBrowser;

// Only production quiets the browser down. Everywhere else — localstack,
// development, staging, and the `pr-*` previews that resolve to development —
// logs everything, because a client-side failure that leaves no trace is the
// reason this was unusable for debugging. The server side stays Debug in every
// mode; it goes to CloudWatch, not to a user's console.
const quietBrowser = isBrowser && clientEnv.mode === 'production';

export const rootLogger = makeAppLogger({
  level: quietBrowser ? 'Warn' : 'Debug',
  // Lambda/production-build server logs go to CloudWatch — keep them
  // structured. Dev server + browser get the pretty console output.
  format:
    isNode && (clientEnv.isLambda || clientEnv.isProdBuild) ? 'json' : 'pretty',
  base: {
    app: '@listening/start',
    env: clientEnv.mode,
  },
});
